/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed.index'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedVillagesIndexRouteImport } from './routes/_authed.villages.index'
import { Route as AuthedRedemptionsIndexRouteImport } from './routes/_authed.redemptions.index'
import { Route as AuthedQrCodesIndexRouteImport } from './routes/_authed.qr-codes.index'
import { Route as AuthedBusinessesIndexRouteImport } from './routes/_authed.businesses.index'
import { Route as AuthedAnalyticsIndexRouteImport } from './routes/_authed.analytics.index'
import { Route as AuthedVillagesVillageIdRouteImport } from './routes/_authed.villages.$villageId'
import { Route as AuthedRoutesRouteIdRouteImport } from './routes/_authed.routes.$routeId'
import { Route as AuthedQrCodesQrIdRouteImport } from './routes/_authed.qr-codes.$qrId'
import { Route as AuthedLocationsLocationIdRouteImport } from './routes/_authed.locations.$locationId'
import { Route as AuthedBusinessesBusinessIdRouteImport } from './routes/_authed.businesses.$businessId'
import { Route as AuthedAnalyticsSuggestionsRouteImport } from './routes/_authed.analytics.suggestions'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedVillagesIndexRoute = AuthedVillagesIndexRouteImport.update({
  id: '/villages/',
  path: '/villages/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRedemptionsIndexRoute = AuthedRedemptionsIndexRouteImport.update({
  id: '/redemptions/',
  path: '/redemptions/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQrCodesIndexRoute = AuthedQrCodesIndexRouteImport.update({
  id: '/qr-codes/',
  path: '/qr-codes/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBusinessesIndexRoute = AuthedBusinessesIndexRouteImport.update({
  id: '/businesses/',
  path: '/businesses/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsIndexRoute = AuthedAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedVillagesVillageIdRoute = AuthedVillagesVillageIdRouteImport.update({
  id: '/villages/$villageId',
  path: '/villages/$villageId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRoutesRouteIdRoute = AuthedRoutesRouteIdRouteImport.update({
  id: '/routes/$routeId',
  path: '/routes/$routeId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQrCodesQrIdRoute = AuthedQrCodesQrIdRouteImport.update({
  id: '/qr-codes/$qrId',
  path: '/qr-codes/$qrId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLocationsLocationIdRoute =
  AuthedLocationsLocationIdRouteImport.update({
    id: '/locations/$locationId',
    path: '/locations/$locationId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedBusinessesBusinessIdRoute =
  AuthedBusinessesBusinessIdRouteImport.update({
    id: '/businesses/$businessId',
    path: '/businesses/$businessId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedAnalyticsSuggestionsRoute =
  AuthedAnalyticsSuggestionsRouteImport.update({
    id: '/analytics/suggestions',
    path: '/analytics/suggestions',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof AuthedSettingsRoute
  '/analytics/suggestions': typeof AuthedAnalyticsSuggestionsRoute
  '/businesses/$businessId': typeof AuthedBusinessesBusinessIdRoute
  '/locations/$locationId': typeof AuthedLocationsLocationIdRoute
  '/qr-codes/$qrId': typeof AuthedQrCodesQrIdRoute
  '/routes/$routeId': typeof AuthedRoutesRouteIdRoute
  '/villages/$villageId': typeof AuthedVillagesVillageIdRoute
  '/analytics/': typeof AuthedAnalyticsIndexRoute
  '/businesses/': typeof AuthedBusinessesIndexRoute
  '/qr-codes/': typeof AuthedQrCodesIndexRoute
  '/redemptions/': typeof AuthedRedemptionsIndexRoute
  '/villages/': typeof AuthedVillagesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/settings': typeof AuthedSettingsRoute
  '/': typeof AuthedIndexRoute
  '/analytics/suggestions': typeof AuthedAnalyticsSuggestionsRoute
  '/businesses/$businessId': typeof AuthedBusinessesBusinessIdRoute
  '/locations/$locationId': typeof AuthedLocationsLocationIdRoute
  '/qr-codes/$qrId': typeof AuthedQrCodesQrIdRoute
  '/routes/$routeId': typeof AuthedRoutesRouteIdRoute
  '/villages/$villageId': typeof AuthedVillagesVillageIdRoute
  '/analytics': typeof AuthedAnalyticsIndexRoute
  '/businesses': typeof AuthedBusinessesIndexRoute
  '/qr-codes': typeof AuthedQrCodesIndexRoute
  '/redemptions': typeof AuthedRedemptionsIndexRoute
  '/villages': typeof AuthedVillagesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/analytics/suggestions': typeof AuthedAnalyticsSuggestionsRoute
  '/_authed/businesses/$businessId': typeof AuthedBusinessesBusinessIdRoute
  '/_authed/locations/$locationId': typeof AuthedLocationsLocationIdRoute
  '/_authed/qr-codes/$qrId': typeof AuthedQrCodesQrIdRoute
  '/_authed/routes/$routeId': typeof AuthedRoutesRouteIdRoute
  '/_authed/villages/$villageId': typeof AuthedVillagesVillageIdRoute
  '/_authed/analytics/': typeof AuthedAnalyticsIndexRoute
  '/_authed/businesses/': typeof AuthedBusinessesIndexRoute
  '/_authed/qr-codes/': typeof AuthedQrCodesIndexRoute
  '/_authed/redemptions/': typeof AuthedRedemptionsIndexRoute
  '/_authed/villages/': typeof AuthedVillagesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/settings'
    | '/analytics/suggestions'
    | '/businesses/$businessId'
    | '/locations/$locationId'
    | '/qr-codes/$qrId'
    | '/routes/$routeId'
    | '/villages/$villageId'
    | '/analytics/'
    | '/businesses/'
    | '/qr-codes/'
    | '/redemptions/'
    | '/villages/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/settings'
    | '/'
    | '/analytics/suggestions'
    | '/businesses/$businessId'
    | '/locations/$locationId'
    | '/qr-codes/$qrId'
    | '/routes/$routeId'
    | '/villages/$villageId'
    | '/analytics'
    | '/businesses'
    | '/qr-codes'
    | '/redemptions'
    | '/villages'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/settings'
    | '/_authed/'
    | '/_authed/analytics/suggestions'
    | '/_authed/businesses/$businessId'
    | '/_authed/locations/$locationId'
    | '/_authed/qr-codes/$qrId'
    | '/_authed/routes/$routeId'
    | '/_authed/villages/$villageId'
    | '/_authed/analytics/'
    | '/_authed/businesses/'
    | '/_authed/qr-codes/'
    | '/_authed/redemptions/'
    | '/_authed/villages/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/villages/': {
      id: '/_authed/villages/'
      path: '/villages'
      fullPath: '/villages/'
      preLoaderRoute: typeof AuthedVillagesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/redemptions/': {
      id: '/_authed/redemptions/'
      path: '/redemptions'
      fullPath: '/redemptions/'
      preLoaderRoute: typeof AuthedRedemptionsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/qr-codes/': {
      id: '/_authed/qr-codes/'
      path: '/qr-codes'
      fullPath: '/qr-codes/'
      preLoaderRoute: typeof AuthedQrCodesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/businesses/': {
      id: '/_authed/businesses/'
      path: '/businesses'
      fullPath: '/businesses/'
      preLoaderRoute: typeof AuthedBusinessesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/': {
      id: '/_authed/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthedAnalyticsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/villages/$villageId': {
      id: '/_authed/villages/$villageId'
      path: '/villages/$villageId'
      fullPath: '/villages/$villageId'
      preLoaderRoute: typeof AuthedVillagesVillageIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/routes/$routeId': {
      id: '/_authed/routes/$routeId'
      path: '/routes/$routeId'
      fullPath: '/routes/$routeId'
      preLoaderRoute: typeof AuthedRoutesRouteIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/qr-codes/$qrId': {
      id: '/_authed/qr-codes/$qrId'
      path: '/qr-codes/$qrId'
      fullPath: '/qr-codes/$qrId'
      preLoaderRoute: typeof AuthedQrCodesQrIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/locations/$locationId': {
      id: '/_authed/locations/$locationId'
      path: '/locations/$locationId'
      fullPath: '/locations/$locationId'
      preLoaderRoute: typeof AuthedLocationsLocationIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/businesses/$businessId': {
      id: '/_authed/businesses/$businessId'
      path: '/businesses/$businessId'
      fullPath: '/businesses/$businessId'
      preLoaderRoute: typeof AuthedBusinessesBusinessIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/suggestions': {
      id: '/_authed/analytics/suggestions'
      path: '/analytics/suggestions'
      fullPath: '/analytics/suggestions'
      preLoaderRoute: typeof AuthedAnalyticsSuggestionsRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAnalyticsSuggestionsRoute: typeof AuthedAnalyticsSuggestionsRoute
  AuthedBusinessesBusinessIdRoute: typeof AuthedBusinessesBusinessIdRoute
  AuthedLocationsLocationIdRoute: typeof AuthedLocationsLocationIdRoute
  AuthedQrCodesQrIdRoute: typeof AuthedQrCodesQrIdRoute
  AuthedRoutesRouteIdRoute: typeof AuthedRoutesRouteIdRoute
  AuthedVillagesVillageIdRoute: typeof AuthedVillagesVillageIdRoute
  AuthedAnalyticsIndexRoute: typeof AuthedAnalyticsIndexRoute
  AuthedBusinessesIndexRoute: typeof AuthedBusinessesIndexRoute
  AuthedQrCodesIndexRoute: typeof AuthedQrCodesIndexRoute
  AuthedRedemptionsIndexRoute: typeof AuthedRedemptionsIndexRoute
  AuthedVillagesIndexRoute: typeof AuthedVillagesIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAnalyticsSuggestionsRoute: AuthedAnalyticsSuggestionsRoute,
  AuthedBusinessesBusinessIdRoute: AuthedBusinessesBusinessIdRoute,
  AuthedLocationsLocationIdRoute: AuthedLocationsLocationIdRoute,
  AuthedQrCodesQrIdRoute: AuthedQrCodesQrIdRoute,
  AuthedRoutesRouteIdRoute: AuthedRoutesRouteIdRoute,
  AuthedVillagesVillageIdRoute: AuthedVillagesVillageIdRoute,
  AuthedAnalyticsIndexRoute: AuthedAnalyticsIndexRoute,
  AuthedBusinessesIndexRoute: AuthedBusinessesIndexRoute,
  AuthedQrCodesIndexRoute: AuthedQrCodesIndexRoute,
  AuthedRedemptionsIndexRoute: AuthedRedemptionsIndexRoute,
  AuthedVillagesIndexRoute: AuthedVillagesIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
